module.exports = __webpack_public_path__ + "static/media/404-bg.dadb0855.jpg";